import { render } from "./EditFeedType.vue?vue&type=template&id=634b95b0"
import script from "./EditFeedType.vue?vue&type=script&lang=js"
export * from "./EditFeedType.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__